import React, { useState } from 'react'
import ReadmorewordsOttTable from './ReadWordsOttTable'

const MovieAndOTTNewsTable = ({
  inputData,
  tableHeaders,
  editIndex,
  renderActions,
  movieAndOTTNewsUpdates,
  type,
}) => {
  const [showAll, setShowAll] = useState(false)

  return (
    <>
      {inputData && movieAndOTTNewsUpdates && movieAndOTTNewsUpdates.length !== 0 && (
        <table
          style={{ fontSize: '10px' }}
          className={`${type === 'person' ? 'personNewsTable' : ''}`}
        >
          <thead>
            {tableHeaders.map((header, index) => (
              <th key={index} className='tdclassName'>
                {header}
              </th>
            ))}
            <th className='tdclassName'>Actions</th>
          </thead>
          <tbody>
            {inputData &&
              movieAndOTTNewsUpdates.slice(0, showAll ? undefined : 3).map((item, index) => (
                <tr key={index}>
                  {tableHeaders.map((header, columnIndex) => (
                    <td
                      key={columnIndex}
                      className={`tdclassName ${
                        (header === 'description_En' || header === 'description_Te') &&
                        editIndex === index
                          ? 'editMode'
                          : ''
                      }`}
                      style={{
                        minWidth:
                          header === 'description_En' || header === 'description_Te'
                            ? '50px'
                            : '10px',
                      }}
                    >
                      {header === 'description_En' || header === 'description_Te' ? (
                        <div>
                          <ReadmorewordsOttTable>{item[header]}</ReadmorewordsOttTable>
                        </div>
                      ) : (
                        item[header]
                      )}
                    </td>
                  ))}
                  <td className='tdclassName'>
                    <div className='movieOttActions'>{renderActions(item, index)}</div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
      {!showAll && inputData && movieAndOTTNewsUpdates.length > 3 && (
        <button
          className='btn btn-primary mt-2'
          type='button
        '
          onClick={() => setShowAll(true)}
        >
          Load More
        </button>
      )}
    </>
  )
}

export default MovieAndOTTNewsTable
